import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Component/axiosInstance";

export const Graphupdate = createAsyncThunk('Graphupdate', async ({id, updatedData}, {rejectWithValue}) => {
    try {
        const response = await axiosInstance.put(`/graph/updateGraphData/${id}`, updatedData, {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem("token")
            }
        });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An Unexpected Error Occurred");
    }
});

const graphdataupdate = createSlice({
    name: 'Graphupdate',
    initialState: {
        loading: false,
        error: null,
        data: null,
        isSuccess: false,
        isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(Graphupdate.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.data = null;
                state.isSuccess = false;
                state.isError = false;
            })
            .addCase(Graphupdate.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.isSuccess = true;
                state.isError = false;
            })
            .addCase(Graphupdate.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.data = null;
                state.isError = true;
                state.isSuccess = false;
            });
    }
});

export default graphdataupdate.reducer;

// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../Component/axiosInstance";

// export const Graphupdate = createAsyncThunk(
//   'graph/update',
//   async ({ id, data }, { rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.put(
//         `/graph/updateGraphData/${id}`,
//         data,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             'x-auth-token': localStorage.getItem("token")
//           }
//         }
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Update failed");
//     }
//   }
// );

// const graphdataupdate = createSlice({
//   name: 'Graphupdate',
//   initialState: {
//     loading: false,
//     error: null,
//     data: null,
//     isSuccess: false
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(Graphupdate.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(Graphupdate.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = action.payload;
//         state.isSuccess = true;
//       })
//       .addCase(Graphupdate.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   }
// });

// export default graphdataupdate.reducer;